import { Card, CardBody } from "reactstrap";
import WizardPanel from "../WizardPanel";

function SummaryTile({ label, value }) {
  return (
    <Card className="mb-2">
      <CardBody className="p-3">
        <small className="text-muted text-uppercase font-weight-bold d-block mb-1">{label}</small>
        <div className="font-weight-bold">{value ?? "—"}</div>
      </CardBody>
    </Card>
  );
}

/** @param {import("../WizardCard").StepPanelProps} props */
export default function SummaryPanel({ installation, dvrStore, status, bottomNav }) {
  const isCloud = installation?.is_cloud;
  const dvrList = (dvrStore.dvrs ?? []).filter((d) => d.id != null);
  const recorderSummary = dvrList.length ? `${dvrList.length} DVR${dvrList.length > 1 ? "s" : ""}` : "—";
  const installType = isCloud === undefined ? "—" : isCloud ? "☁ Cloud" : "🏠 Local";
  const lanIps = dvrList
    .map((d) => d.dvr_ipv4)
    .filter(Boolean)
    .join(", ");
  const networkPath = isCloud ? installation?.ddns_url || "—" : lanIps || "Local install";
  const networkLabel = isCloud ? "DDNS" : "Video Recorder LAN IP";

  const tiles = [
    { label: "Client ID", value: installation?.location },
    { label: "Email", value: installation?.client_email },
    { label: "Video Recorders", value: recorderSummary },
    { label: "Installation type", value: installType },
    { label: networkLabel, value: networkPath },
    {
      label: "Cameras",
      value: installation?.camera_count != null ? `${installation.camera_count} camera(s)` : "—",
    },
    { label: "Quality Review", value: "✅ Validated" },
    { label: "AppTune User", value: "✅ Created" },
  ];

  return (
    <WizardPanel
      title="Installation finalized"
      subtitle="The store is configured on Veesion Manager and AppTune"
      status={status}
      bottomNav={bottomNav}
    >
      <div className="text-center pt-4 pb-3">
        <div className="display-4 mb-2">✅</div>
        <h4 className="text-success font-weight-bold">Installation successfully configured</h4>
        <small className="text-muted">
          The store has been automatically configured on Veesion Manager &amp; AppTune.
        </small>
      </div>

      <div
        className="mt-3"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: "0.6rem",
        }}
      >
        {tiles.map((tile) => (
          <SummaryTile key={tile.label} label={tile.label} value={tile.value} />
        ))}
      </div>
    </WizardPanel>
  );
}
